import { Alert, AnchorLinkButton } from "@vericus/cadmus-ui";

/**
 * Persistent notice that another tab replaced this tab's session.
 *
 * Not dismissible, and deliberately offers no reload: the shared cookie now
 * belongs to the other tab, so reloading would re-boot this one under the wrong
 * identity. Relaunching from the LMS is the only remedy.
 *
 * The app stays mounted and interactive behind it, so unsaved work can still be
 * read and copied out.
 */
export function SessionExpiredBanner() {
  return (
    <Alert
      severity="error"
      title="Your session has expired"
      linkComp={
        <AnchorLinkButton
          inline
          kind="solid"
          external
          href="https://support.cadmus.io/kb-tickets/new"
        >
          Contact us for help
        </AnchorLinkButton>
      }
    >
      Changes on this page {"won't"} save — copy anything unsaved, then relaunch
      this assessment from your Learning Management System.
    </Alert>
  );
}
